module.exports = __webpack_public_path__ + "img/eye-open.6109dde7.svg";